import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { ThreeDots } from "react-loader-spinner";
import Header from "./partials/header";
import Footer from "./partials/footer";
import { ApiUrl, fetchWithCache } from "../components/API/Api";
const MainLayout = () => {
  const [loading, setLoading] = useState(true);
  const [Homedata, setHomedata] = useState(null);

  let location = useLocation();

  const url = location.pathname;

  const [pageTitle, setPageTitle] = useState("");

  useEffect(() => {
    const path = {
      "/about-mmi": "About Us",
      "/history": "History",
      "/general-admin": "General Administration",
      "/province": "African Province",
      "/vice-province": "Vice Province",
      "/delegations": "Delegation",
      "/country-heads": "Country Head",
      "/sprituality": "Spirituality",
      "/our-presence": "Our Presence",
      "/african-province": "African Province",
      "/rome": "Rome",
      "/francis-province": "St. Francis Xavier Province",
      "/malawi": "Malawi",
      "/papuva-new-guinea": "Papua New Guinea",
      "/tanzanian": "Tanzanian Presence",
      "/vocations": "Vocation",
      "/formation": "Formation",
      "/gallery": "Photo Gallery",
      "/video-gallery": "Video Gallery",
      "/privacy-policy": "Privacy Policy",
      "/contact-us": "Contact Us",
      "/calendar": "Calendar",
      "/founder-message": "Founder Message",
      "/bishop-message": "Patron Message",
      "/blog": "Blog",
    };
    // If the route is a blog post, decode the slug for display
    if (url.startsWith("/blog/")) {
      const slug = url.replace("/blog/", "");
      setPageTitle(decodeURIComponent(slug).replace(/-/g, " "));
    } else {
      setPageTitle(path[url] ? path[url] : url);
    }
  }, [url]);

  useEffect(() => {
    fetchWithCache(
      `${ApiUrl}/get/homepagee/sections`,
      setHomedata,
      "HomeData",
      setLoading,
      (res) => res?.data
    );
  }, []);

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <ThreeDots
          visible={true}
          height="50"
          width="50"
          color="#172440"
          radius="9"
          ariaLabel="three-dots-loading"
          wrapperStyle={{}}
          wrapperClass=""
        />
      </div>
    );
  }
  return (
    <>
      <Header menudata={Homedata?.headermenudata} />
      <div style={{ minHeight: "66.5vh" }}>
        <div className="home-mother">
          <div className="container" style={{ padding: 30 }}>
            <h3 className="entry-title motherhouse">
              <span style={{ color: "#b69000" }}>{pageTitle}</span>
            </h3>
            <div className="brudcrums">
              <a href="/">Home &nbsp;»&nbsp; </a>
              <span className="pagename">{pageTitle}</span>
            </div>
          </div>
        </div>

        <Outlet />
      </div>
      <Footer footerdata={Homedata?.footercontactdata} />
    </>
  );
};

export default MainLayout;
